:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._emptyStateContainer_1aa30_7 {
  display: flex;
  height: 100%;
  margin: 20px 0;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  pointer-events: all;
  z-index: 100; }
  ._emptyStateContainer_1aa30_7 ._linksContainer_1aa30_16,
  ._emptyStateContainer_1aa30_7 > .control-text {
    color: #3b4057; }
  ._emptyStateContainer_1aa30_7._light_1aa30_19 ._linksContainer_1aa30_16,
  ._emptyStateContainer_1aa30_7._light_1aa30_19 > .control-text {
    color: #fff; }
  ._emptyStateContainer_1aa30_7 ._linksContainer_1aa30_16 {
    display: inline-block;
    margin-top: 3px;
    line-height: 18px; }
    ._emptyStateContainer_1aa30_7 ._linksContainer_1aa30_16 > .control-text-button {
      vertical-align: bottom; }
